import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  Popover,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomButton from "../../../Components/CustomButton";
import CustomSelect from "../../../Components/CustomSelect";
import CustomInput from "../../../Components/CustomInput";
import ModalForms from "../../../Components/Simple Purchase/ModalForms";
import CustomSnackbar from "../../../Components/CustomSnackbar";
import { toast } from "react-toastify";
import {
  createNewContact,
  getContacts,
  getContactById,
} from "../../../redux/slices/contactSlice";
import {
  getSuppliers,
  getSupplierAddress,
} from "../../../redux/slices/supplierSlice";
import { connect } from "react-redux";
import CreditNoteTable from "./CreditNoteTable";
// import { useNavigationBlocker } from "../../../hooks/useNavigationBlocker";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
// import { usePrompt } from "../../../hooks/usePrompt";
import EmailModal from "../../../Components/shared/Modals/EmailModal";
import CreditNotePrintTemplate from "../../../Components/shared/Modals/CreditNotePrintTemplate";
import { useSelector } from "react-redux";
import {
  purchaseCreditNoteInitialValues,
  purchaseCreditNoteValidationSchema,
} from "../../../formSchemas/purchaseCreditNoteSchema";
import { useFormik } from "formik";
import { creaditNotePrintData } from "./creditNoteData";
import { getModalConfig } from "../../../utils/getAddModalData";
// import { useFormNavigationGuard } from "../../../hooks/useFormNavigationGuard";
// import { useNavigationBlocker, usePrompt } from "../../../hooks/usePrompt";
import { useNavigation } from "../../../context/NavigationContext";
// import useLeavePageConfirm from "../../../hooks/useLeavePageConfirm";

const PurchaseCreditNote = ({
  createContact,
  getSupplierList,
  getContact,
  supplierAddress,
}) => {
  const { suppliersListLoading } = useSelector((state) => state.supplier);
  const { setIsFormDirtyCondition } = useNavigation();
  const [open, setOpen] = useState(true);
  const [openEmailTemplate, setOpenEmailTemplate] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);
  const [formData, setFormData] = useState({
    supplier: "",
    contact: "",
    supplierAddress1: "",
    location: "",
    terms: "",
    taxRule: "",
  });
  // For popover
  const [anchorEl, setAnchorEl] = useState(null);
  const [contactOptions, setContactOptions] = useState([]);
  const [selectedSupplierData, setSelectedSupplierData] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [addressOptions, setAddressOptions] = useState([]);
  const openPopover = Boolean(anchorEl);

  const [openModal, setOpenModal] = useState({
    newSupplier: false,
    newContact: false,
    newPaymentTerm: false,
    newLocation: false,
    newCompanyAddress: false,
    newSupplierAddress: false,
    newShippingAddress: false,
  });
  const [data, setData] = useState([]);
  const [ccOptions, setCcOptions] = useState([]);
  const [isFormDirty, setIsFormDirty] = useState(false);

  // Add state to track selected "to" contact
  const [emailForm, setEmailForm] = useState({
    to: "",
    cc: ccOptions,
    subject: formData?.supplier
      ? `Credit Note for emailForm${formData.supplier}`
      : "",
    message: "",
    attachment: true,
  });

  useEffect(() => {
    if (selectedSupplierData) {
      const requiredCCOptions = selectedSupplierData?.map((supplier) => ({
        value: supplier?.id,
        label: supplier?.name,
      }));
      setCcOptions(requiredCCOptions);
    }
  }, [selectedSupplierData]);

  const formik = useFormik({
    initialValues: purchaseCreditNoteInitialValues,
    validationSchema: purchaseCreditNoteValidationSchema,
    onSubmit: (values) => console.log(values),
  });
  const isSupplierSelected = !!formik.values.supplier;

  const { values, handleChange, touched, errors } = formik;

  const isRequiredFieldsFilled = values.supplier && values.creditNoteDate;

  const handleUnifiedChange = (e, value) => {
    const { name } = e?.target || {}; // for MUI Autocomplete, value comes separately
    const newValue = value ?? e?.target?.value;

    setIsFormDirty(true);
    formik.setFieldValue(name, newValue); // Update Formik's internal state
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const checkboxChange = (event) => {
    const { name, type, value, checked } = event.target;
    setIsFormDirty(true);
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const handleAddClick = (label) => {
    if (
      label !== "Supplier" &&
      (!formData.supplier || formData.supplier === "Select")
    ) {
      toast.warn("You need to select a supplier first");
      return;
    }

    const config = getModalConfig(label);
    if (config) {
      setOpenModal({ [config.modalKey]: true });
      setData(config.data);
    }
  };
  const handleCreateContact = async (values) => {
    const data = {
      firstName: values?.firstName,
      lastName: values?.lastName || "",
      email: values?.email,
      phone: values?.phone,
      // supplier: supplier,
    };
    const response = await createContact(data);
    if (createNewContact.fulfilled.match(response)) {
      setOpenModal({ newContact: false });
    }
  };
  const handleExpand = () => {
    setOpen(!open);
  };

  useEffect(() => {
    const fetchSuppliers = async () => {
      const response = await getSupplierList();
      if (response?.payload?.data?.length) {
        // setSupplierOptions(response?.payload?.data?.map((item) => `${item.name}`));
        setSupplierOptions(response?.payload?.data || []);
      }
    };
    fetchSuppliers();
  }, [getSupplierList]);

  useEffect(() => {
    if (!isFormDirty) return;

    let isHandlingPopState = false;

    // Add initial trap state
    window.history.pushState({ isTrappingState: true }, "");

    const handlePopState = (event) => {
      if (event.state?.isTrappingState || isHandlingPopState) return;

      isHandlingPopState = true;

      const confirmLeave = window.confirm(
        "You have unsaved changes. Are you sure you want to leave?"
      );

      if (!confirmLeave) {
        // Re-push our trap state
        window.history.pushState({ isTrappingState: true }, "");
      } else {
        // User confirmed navigation - update context
        setIsFormDirtyCondition(false);

        // Allow navigation by going back to the original state
        window.history.go(-1);
      }

      isHandlingPopState = false;
    };

    window.addEventListener("popstate", handlePopState);

    // Handle page refresh/close
    const handleBeforeUnload = (event) => {
      if (isFormDirty) {
        event.preventDefault();
        event.returnValue =
          "You have unsaved changes. Are you sure you want to leave?";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("beforeunload", handleBeforeUnload);

      // Clean up our trap state if it exists
      if (window.history.state?.isTrappingState) {
        window.history.back();
      }
    };
  }, [isFormDirty, setIsFormDirtyCondition]);

  useEffect(() => {
    const fetchRelatedContactAndAddress = async (selectedSupplier) => {
      if (!selectedSupplier) {
        return;
      }
      const label = selectedSupplier.name;
      const option = {
        label,
        value: selectedSupplier.id,
        ...selectedSupplier, // optional: keep full data if needed later
      };

      setSelectedSupplierData([option]);

      try {
        const contactHref = selectedSupplier?.contacts?.[0]?.href;
        if (contactHref) {
          const contactId = contactHref.split("/").pop();
          const response = await getContact({ id: contactId });

          const contactData = response?.payload;

          if (contactData) {
            const label = `${contactData.firstName || ""} ${
              contactData.lastName1 || ""
            }`.trim();
            const option = {
              label,
              value: contactData.id,
              ...contactData, // optional: keep full data if needed later
            };

            setContactOptions([option]);

            formik.setFieldValue("contact", label);
            setFormData((prev) => ({ ...prev, contact: label }));
          }
        }
        // Address
        const addressHref = selectedSupplier?.addresss?.[0]?.href;
        if (addressHref) {
          const addressId = addressHref.split("/").pop();

          const addressResponse = await supplierAddress(addressId);

          const address = addressResponse?.payload;

          if (address) {
            const line1 = address?.address_line_1 || "";
            const option = {
              label: line1,
              value: address.id,
              ...address, // keep full object if needed for later
            };
            const line2 = address?.address_line_2 || "";

            setAddressOptions([option]); // make sure `setAddressOptions` exists
            formik.setFieldValue("supplierAddress1", line1);
            formik.setFieldValue("supplierAddress2", line2);
            setFormData((prev) => ({ ...prev, supplierAddress1: line1 }));
          }
        }
      } catch (err) {
        console.error("Error fetching contact/address:", err);
      }
    };

    if (formik.values.supplier) {
      const selectedSupplier = supplierOptions.find(
        (s) => s.name === formik.values.supplier
      );

      if (selectedSupplier) {
        const autoFill = {
          taxRule: selectedSupplier.tax_rule || "",
          terms: selectedSupplier.patment_terms?.toString() || "",
          currency: selectedSupplier.currency || "",
        };

        Object.entries(autoFill).forEach(([key, value]) => {
          formik.setFieldValue(key, value);
        });

        setFormData((prev) => ({
          ...prev,
          ...autoFill,
        }));

        fetchRelatedContactAndAddress(selectedSupplier);
      }
    }
  }, [formik.values.supplier, supplierOptions]);

  useEffect(() => {
    if (isFormDirty) {
      setIsFormDirtyCondition(true);
    }
  }, [isFormDirty, setIsFormDirtyCondition]);

  return (
    <Box sx={{ paddingY: 1 }}>
      <CustomSnackbar />
      {/* Header Section */}
      <form onSubmit={formik.handleSubmit}>
        <Box sx={{ mb: 2, bgcolor: "white", borderRadius: "10px" }}>
          <ModalForms
            open={openModal.newSupplier}
            data={data}
            setOpen={setOpenModal}
            name={"New Supplier"}
          />
          <ModalForms
            open={openModal.newContact}
            data={data}
            setOpen={setOpenModal}
            name={"Add Supplier Contact"}
            handleSave={handleCreateContact}
          />
          <ModalForms
            open={openModal.newSupplierAddress}
            data={data}
            setOpen={setOpenModal}
            name={"Add Supplier's Address"}
          />
          <ModalForms
            open={openModal.newPaymentTerm}
            data={data}
            setOpen={setOpenModal}
            name={"Add Payment Term"}
          />
          <ModalForms
            open={openModal.newLocation}
            data={data}
            setOpen={setOpenModal}
            name={"Add new Location"}
          />
          <ModalForms
            open={openModal.newShippingAddress}
            data={data}
            setOpen={setOpenModal}
            name={"Add Shipping Address"}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid #38535E",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#FEE28A",
                  color: "black",
                  textTransform: "none",
                  m: 2,
                }}
              >
                New
              </Button>
              <Typography sx={{ fontSize: "16px" }}>NEW CREDIT NOTE</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* Desktop buttons - shown above md breakpoint */}
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  "@media (max-width: 900px)": { display: "none" },
                }}
              >
                <CustomButton
                  text={"Email"}
                  width={"25%"}
                  border={!isRequiredFieldsFilled ? "gray" : "black"}
                  img={
                    <EmailOutlinedIcon
                      sx={{
                        color: !isRequiredFieldsFilled ? "gray" : "black",
                        font: "icon",
                      }}
                    />
                  }
                  color={"black"}
                  onClick={() => setOpenEmailTemplate(true)}
                  disabled={!isRequiredFieldsFilled}
                />
                <CustomButton
                  text={" Print"}
                  width={"25%"}
                  border={!isRequiredFieldsFilled ? "gray" : "black"}
                  color={"black"}
                  img={
                    <PrintOutlinedIcon
                      sx={{
                        color: !isRequiredFieldsFilled ? "gray" : "black",
                        font: "icon",
                      }}
                    />
                  }
                  onClick={() => setOpenPrint(true)}
                  disabled={!isRequiredFieldsFilled}
                />
              </Box>

              {/* Mobile menu icon - only shown below md breakpoint */}
              <IconButton
                onClick={handlePopoverOpen}
                sx={{
                  "@media (min-width: 901px)": { display: "none" },
                }}
              >
                <MoreVertIcon />
              </IconButton>

              {/* Keeping the expand/collapse IconButton as requested */}
              <IconButton onClick={handleExpand}>
                {open ? <ExpandLess /> : <ExpandMore />}
              </IconButton>

              {/* Popover for buttons on smaller screens */}
              <Popover
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  <CustomButton
                    text={"Email"}
                    img={
                      <EmailOutlinedIcon
                        sx={{
                          color: !isRequiredFieldsFilled ? "gray" : "black",
                          font: "icon",
                        }}
                      />
                    }
                    width={"100px"}
                    border={!isRequiredFieldsFilled ? "gray" : "black"}
                    color={"black"}
                    onClick={() => setOpenEmailTemplate(true)}
                    disabled={!isRequiredFieldsFilled}
                  />
                  <CustomButton
                    text={" Print"}
                    img={
                      <PrintOutlinedIcon
                        sx={{
                          color: !isRequiredFieldsFilled ? "gray" : "black",
                          font: "icon",
                        }}
                      />
                    }
                    width={"100px"}
                    border={!isRequiredFieldsFilled ? "gray" : "black"}
                    color={"black"}
                    onClick={() => setOpenPrint(true)}
                    disabled={!isRequiredFieldsFilled}
                  />
                </Box>
              </Popover>
            </Box>
          </Box>
          {open && (
            <>
              <Grid container spacing={2} sx={{ p: 2 }}>
                {/* Row 1 */}
                <Grid item xs={12} md={6}>
                  <CustomSelect
                    label="Supplier"
                    name="supplier"
                    handleChange={handleUnifiedChange}
                    handleAddClick={handleAddClick}
                    value={formData.supplier}
                    data={supplierOptions.map((s) => s.name)}
                    isLoading={suppliersListLoading}
                    add
                    required
                    searchable
                    error={touched.supplier && Boolean(errors.supplier)}
                    helperText={touched.supplier && errors.supplier}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomInput
                    label="Credit Note Date"
                    name="creditNoteDate"
                    type="date"
                    value={formData.creditNoteDate}
                    onChange={handleChange}
                    height="40px"
                    required
                    error={
                      touched.creditNoteDate && Boolean(errors.creditNoteDate)
                    }
                    helperText={touched.creditNoteDate && errors.creditNoteDate}
                  />
                </Grid>

                {/* Row 2 */}
                <Grid item xs={12} md={6}>
                  <CustomSelect
                    label="Contacts"
                    name="contact"
                    handleAddClick={handleAddClick}
                    add
                    searchable
                    value={formik.values.contact}
                    handleChange={handleUnifiedChange}
                    data={contactOptions}
                    disabled={!isSupplierSelected}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomSelect
                    label="Tax Rule"
                    name="taxRule"
                    searchable
                    value={formik.values.taxRule}
                    data={["Tax Free", "GST", "HST", "PST"]}
                    handleChange={handleUnifiedChange}
                    disabled={!isSupplierSelected}
                  />
                </Grid>

                {/* Row 3 */}
                <Grid item xs={12} md={6}>
                  <CustomInput
                    label="Phone"
                    name="phone"
                    type="number"
                    value={formData.phone}
                    onChange={handleChange}
                    height="40px"
                    disabled={!isSupplierSelected}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomInput
                    type="checkbox"
                    name="taxInclusive"
                    label="Tax Inclusive"
                    value={formData.taxInclusive}
                    onChange={checkboxChange}
                  />
                </Grid>

                {/* Row 4 */}
                <Grid item xs={12} md={6}>
                  <CustomSelect
                    label="Supplier's Address Line 1"
                    name="supplierAddress1"
                    handleAddClick={handleAddClick}
                    add
                    handleChange={handleUnifiedChange}
                    searchable
                    value={formData.supplierAddress1}
                    data={addressOptions}
                    disabled={!isSupplierSelected}
                  />
                </Grid>

                {/* Row 5 */}
                <Grid item xs={12} md={6}>
                  <CustomInput
                    label="Vendor Address Line 2"
                    name="supplierAddress2"
                    value={formik.values.supplierAddress2}
                    onChange={handleChange}
                    height="40px"
                    disabled={!isSupplierSelected}
                  />
                </Grid>
                {/* Empty Grid to balance the row */}
                <Grid item xs={12} md={6}></Grid>
              </Grid>
            </>
          )}
        </Box>
      </form>

      {/* Credit note Table */}
      <CreditNoteTable />

      {openEmailTemplate && (
        <EmailModal
          open={openEmailTemplate}
          to={emailForm.to}
          cc={ccOptions}
          subject={emailForm.subject}
          message={emailForm.message}
          attachment={emailForm.attachment}
          onClose={() => setOpenEmailTemplate(false)}
          onSend={() => {
            setOpenEmailTemplate(false);
          }}
          onFieldChange={(field, value) =>
            setEmailForm((prev) => ({ ...prev, [field]: value }))
          }
          contactOptions={contactOptions}
          supplierOptions={supplierOptions}
        />
      )}

      <CreditNotePrintTemplate
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        creditNoteDetails={creaditNotePrintData}
      />
    </Box>
  );
};

const mapDispatchToProps = (dispatch) => ({
  createContact: (data) => dispatch(createNewContact(data)),
  getContactList: (data) => dispatch(getContacts(data)),
  getSupplierList: (data) => dispatch(getSuppliers(data)),
  supplierAddress: (data) => dispatch(getSupplierAddress(data)),
  getContact: (data) => dispatch(getContactById(data)),
});

export default connect(null, mapDispatchToProps)(PurchaseCreditNote);
